import { ExpensesEntitiesExpensableResourceTypeEnum } from 'generated/resources/graphql'
import { z } from 'zod'

import i18n from 'modules/core/lib/i18n'

import { CustomizationField, isMandatory } from 'modules/expenses/hooks/useExpensesCustomization'

interface FormContext {
  customizationFields: CustomizationField[]
  resourceType: ExpensesEntitiesExpensableResourceTypeEnum
}

const defaultRequiredMessage = () => ({
  message: i18n.t('expenses_v2.forms.errors.required'),
})

export const DateTimeSchema = ({ customizationFields, resourceType }: FormContext) => {
  return z.object({
    start_date: z
      .string()
      .optional()
      .nullable()
      .refine(
        (start_date) =>
          isMandatory('start_date', resourceType, customizationFields) ? !!start_date : true,
        defaultRequiredMessage()
      ),
    end_date: z
      .string()
      .optional()
      .nullable()
      .refine(
        (end_date) =>
          isMandatory('end_date', resourceType, customizationFields) ? !!end_date : true,
        defaultRequiredMessage()
      ),
  })
}

export type DateTimeSchema = z.infer<ReturnType<typeof DateTimeSchema>>
